import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TableCell } from '@mui/material';
import { QuestionnaireTemplate } from '../../../types/questionnaireTemplates.types';
import { formatDateTime } from '../../../utils/dates';
import Table, { HeadCell } from '../../Table/Table';
import { useQuestionnaireTemplates } from '../hooks/useQuestionnaireTemplates';

const headCells: HeadCell<QuestionnaireTemplate>[] = [
  {
    id: 'title',
    label: 'Title'
  },
  {
    id: 'questionnaireType',
    label: 'Type'
  },
  {
    id: 'createdTimestamp',
    label: 'Created'
  }
];

function formatType(type: string) {
  return type.replace(/_/g, ' ').replace(/\b(\w)/g, l => l.toUpperCase());
}

export const QuestionnaireTemplatesPage: React.FC = () => {
  const navigate = useNavigate();
  const { handleTemplateClick, templates } = useQuestionnaireTemplates();

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => navigate('/questionnaire-templates/new')}
        >
          Add new
        </Button>
      </Box>

      <Table<QuestionnaireTemplate>
        defaultSorting="title"
        headCells={headCells}
        rows={templates}
        onRowClick={handleTemplateClick}
      >
        {row => (
          <Fragment>
            <TableCell>{row.title}</TableCell>
            <TableCell>{formatType(row.questionnaireType as string)}</TableCell>
            <TableCell>
              {formatDateTime(row.createdTimestamp as string)}
            </TableCell>
          </Fragment>
        )}
      </Table>
    </Box>
  );
};
